<template>
  <div class="editPassword">
    <div class="topimg"><img src="@/assets/img/toppic2.png" alt="" /></div>
    <div class="contant">
      <div class="title">修改密码</div>
      <div class="formbox">
        <div class="input">
          <input type="text" name="" v-model="password" placeholder="请输入旧密码" />
        </div>
        <div class="input">
          <input type="password" name="" v-model="new_password" placeholder="请输入新密码" />
        </div>
        <div class="input">
          <input type="password" name="" v-model="new_password1" placeholder="请确认新密码" />
        </div>
        <button type="button" @click="modifyPw">修改</button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted,ref } from "vue";
import { useRouter } from "vue-router";
import { Toast } from "vant";
import mitts from "@/bus";
import API from "@/axios";

const router = useRouter();
const password = ref('');
const new_password = ref('');
const new_password1 = ref('');
let first_path = '/count/myHome';

onMounted(() => {
  setTimeout(() => {
    mitts.emit("closeLoading");
  }, 500);
  getData();
});
function getData() {
  API({
    url: "/web/editPassword",
    method: "get",
  }).then((res) => {
    mitts.emit('navs', res.data.data.navs);
    mitts.emit("closeLoading");
  });
}

function modifyPw() {
  if(new_password.value != new_password1.value){
    Toast.fail('确认新密码错误');
    return false;
  }
  API({
    url: '/web/modifyPw',
    method: "post",
    data:{new_password:new_password.value,password:password.value},
  }).then((res) => {
    Toast.success(res.data.msg);
    if(res.data.status == 200){
      setTimeout(function(){
        mitts.emit("showLoading");
        router.push({
          path: first_path
        });
      }, 3000);
    }
  });
}
</script>

<style lang="less" scoped>
.topimg {
  width: 100%;
  img {
    width: 100%;
    display: block;
  }
}
.contant {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  display: flex;
  flex-flow: column;
  box-sizing: border-box;
  padding: 0 30px;
}
.title {
  font-size: @title-size;
  font-weight: bolder;
  font-family: "Regular";
  color: @font-white-color;
  line-height: @title-size;
  padding: 70px 0 105px 0;
}
.formbox {
  width: 100%;
  background: @font-white-color;
  box-shadow: 0 0 10px #d7d7d7;
  height: 587px;
  border-radius: 10px;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  .input {
    display: flex;
    align-items: center;
    padding: 28px 0;
    border-bottom: 1px solid @font-third-color;
    width: 497px;
    box-sizing: border-box;
    margin: 0 auto;
    margin-bottom: 20px;
    span {
      font-size: @subtitle-size;
      color: @font-color;
      margin-right: 20px;
      font-weight: bold;
    }
    input {
      flex: 1;
      font-size: @subtitle-size;
      color: @font-secondary-color;
      outline: none;
    }
  }
  .input:last-of-type {
    margin-bottom: 50px;
  }
  button {
    display: block;
    width: 497px;
    margin: 0 auto;
    height: 98px;
    outline: none;
    background: @theme-secondary-color;
    color: #fff;
    font-size: @subtitle-size;
    font-family: "Bold";
    border-radius: 10px;
  }
}
</style>
